export interface IMandatCreate {
  telephone?: string;
  ej?: string;
  iban?: string;
  nom?: string;
}

export class MandatCreate implements IMandatCreate {
  constructor(
    public telephone?: string,
    public ej?: string,
    public iban?: string,
    public tiers?: string
  ) {
  }
}
